export { VpVideoCompilationsTable } from './VpVideoCompilationsTable';



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpVideoCompilationTable/index.js